import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/config-global';

import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.site.basePath}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
  category: icon('ic-category'),
};

// ----------------------------------------------------------------------

export const navData = [
  /**
   * Overview
   */
  {
    subheader: 'Genel',
    items: [
      {
        title: 'Ana Sayfa',
        path: paths.dashboard.home,
        icon: ICONS.dashboard,
        id: 'dashboard-nav',
      },
      {
        title: 'Şubeler',
        path: paths.dashboard.branches.root,
        icon: ICONS.tour,
        id: 'branches-nav',
      },
      {
        title: 'Kategoriler',
        path: paths.dashboard.categories.root,
        icon: ICONS.blog,
        id: 'categories-nav',
      },
      {
        title: 'Ürünler',
        icon: ICONS.order,
        path: paths.dashboard.product.list,
        id: 'products-nav',
      },
      {
        title: 'Sıralama',
        icon: ICONS.menuItem,
        path: paths.dashboard.sorting.root,
        id: 'sorting-nav',
      },
    ],
  },
];
